import { Button, Checkbox, FormControlLabel, IconButton, Typography } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { FC, ReactNode } from 'react';
import { ReactComponent as Close } from '../../../Asset/svg/close.svg';
import useStyles from './style';

export type VideoModalCheckboxState = {
  mute: boolean;
  setMute: (value: boolean) => void;
  checkedAuto: boolean;
  setCheckedAuto: (value: boolean) => void;
};

type VideoModalHeaderProps = {
  title: string;
  onClose: () => void;
};

export const VideoModalHeader: FC<VideoModalHeaderProps> = ({ title, onClose }) => {
  const classes = useStyles();
  return (
    <div className={classes.videoModalHeader}>
      <Typography id="video-import-dialog" className={classes.videoModalTitle}>
        {title}
      </Typography>
      <IconButton aria-label="Fermer" className={classes.videoModalCloseBtn} onClick={onClose}>
        <Close className={classes.videoModalCloseIcon} />
      </IconButton>
    </div>
  );
};

export const VideoModalCheckboxes: FC<VideoModalCheckboxState> = ({
  mute,
  setMute,
  checkedAuto,
  setCheckedAuto,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.videoModalCheckboxes}>
      <FormControlLabel
        className={classes.videoModalCheckboxRow}
        control={
          <Checkbox
            checked={mute}
            onChange={e => setMute(e.target.checked)}
            color="primary"
            className={classes.videoModalCheckbox}
          />
        }
        label={<span className={classes.videoModalCheckboxLabel}>Son actif</span>}
      />
      <FormControlLabel
        className={classes.videoModalCheckboxRow}
        control={
          <Checkbox
            checked={checkedAuto}
            onChange={e => setCheckedAuto(e.target.checked)}
            color="primary"
            className={classes.videoModalCheckbox}
          />
        }
        label={<span className={classes.videoModalCheckboxLabel}>Lecture auto</span>}
      />
    </div>
  );
};

type VideoModalActionsProps = {
  validateLabel?: ReactNode;
  validateDisabled?: boolean;
  onValidate: () => void;
  onBack: () => void;
};

export const VideoModalActions: FC<VideoModalActionsProps> = ({
  validateLabel = 'Valider',
  validateDisabled,
  onValidate,
  onBack,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.videoModalActions}>
      <Button
        variant="contained"
        className={classes.videoModalValidateBtn}
        disabled={validateDisabled}
        onClick={onValidate}>
        {validateLabel}
      </Button>
      <button type="button" className={classes.videoModalBackBtn} onClick={onBack}>
        <ArrowBackIcon className={classes.videoModalBackIcon} />
        Retour
      </button>
    </div>
  );
};
